import React, { useEffect, useState } from 'react'
import './VideoTagsSelectContainer.scss'
import VideoTagSelect from '../VideoTagSelect/VideoTagSelect'
import { GET_ALL_TAGS } from '../../../config/endpoints'
import axios from 'axios'

const VideoTagsSelectContainer = ({ selectedTagList = [], setSelectedTagList }) => {

  const [tagsFetchedSuccessfull, setTagsFetchedSuccessfull] = useState(true);
  const tagsFetchedFailureMsg = "Unable to fetch tags";
  const [tagList, setTagList] = useState([]);
  const [selectionType, setSelectionType] = useState('skills');
  const jwtToken = localStorage.getItem("BQS_TOKEN");



  useEffect(() => {

    getAllTags();
  }, []);

  const getAllTags = async () => {
    try {
      const response = await axios.get(GET_ALL_TAGS, {
        headers: {
          "Authorization": `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 200) {
        const sortedTags = response.data.data.sort((a, b) => a.tagName.localeCompare(b.tagName));
        setTagList(sortedTags);
      } else {

        setTagsFetchedSuccessfull(false);
      }
    } catch (err) {
      setTagsFetchedSuccessfull(false);
    }
  };



  const addTagsToSelectedTagList = (rawTag) => {
    if (!rawTag || !setSelectedTagList) return;
    const parsedTag = JSON.parse(rawTag);
    setSelectedTagList((prev = []) => {
      if (prev.some((tag) => tag._id === parsedTag._id)) {
        return prev;
      }
      return [...prev, parsedTag];
    });
  };

  const removeTagFromSelectedTagList = (indexToRemove) => {
    if (!setSelectedTagList) return;
    setSelectedTagList((prev = []) => prev.filter((_, idx) => idx !== indexToRemove));
  };

  return (


    <div className='video-tags-select-container'>
      {!tagsFetchedSuccessfull ? tagsFetchedFailureMsg : <div></div>}
      <div className="selection-type-container">
        <div className="radio-group">
          <label className="radio-label">
            <input
              type="radio"
              name="tagType"
              value="skills"
              checked={selectionType === 'skills'}
              onChange={() => setSelectionType('skills')}

            />
            Skills Assessment
          </label>
          <label className="radio-label">
            <input
              type="radio"
              name="tagType"
              value="agility"
              checked={selectionType === 'agility'}
              onChange={() => setSelectionType('agility')}

            />
            Agility Assessment
          </label>
          <label className="radio-label">
            <input
              type="radio"
              name="tagType"
              value="matches"
              checked={selectionType === 'matches'}
              onChange={() => setSelectionType('matches')}

            />
            Matches
          </label>
        </div>

        {selectionType && (
          <div className='tagListDropdown'>
            <select
              id="tags"
              defaultValue=""
              value=""
              onChange={(e) => {
                addTagsToSelectedTagList(e.target.value);
              }}
            >
              <option value="" disabled>Select Tag</option>
              {tagList
                .filter(tag => {
                  const name = tag.tagName.toLowerCase().trim();

                  const skillsTags = [
                    'air toss', 'backhand airtoss', 'backhand grip', 'backhand serve',
                    'forehand airtoss', 'forehand grip', 'forehand keep', 'forehand lift',
                    'forehand smash', 'onestep backhand keep', 'onestep backhand lift',
                    'onestep forehand keep', 'onestep forehand lift', 'standing backhand keep',
                    'standing backhand lift', 'standing forehand keep', 'standing forehand lift'
                  ];

                  const agilityTags = [
                    'balance', 'box run', 'box running', 'jumping jack', 'knee jump',
                    'shuffle jump', 'shuttle throw', 'split jumps', 'stationary jumping',
                    'throwing and catching', 'toe tap'
                  ];

                  const matchTags = [
                    'broadcast videos', 'match video', 'user videos'
                  ];

                  if (selectionType === 'skills') return skillsTags.includes(name);
                  if (selectionType === 'agility') return agilityTags.includes(name);
                  if (selectionType === 'matches') return matchTags.includes(name);

                  return false;
                })
                .map((tag) => (
                  <option key={tag._id} value={JSON.stringify(tag)}>
                    {tag.tagName}
                  </option>
                ))
              }
            </select>
          </div>
        )}
      </div>


      <div>
        <div className='video-tags'>
          {selectedTagList.map((tagDetails, index) =>
          (<VideoTagSelect
            key={tagDetails._id || `${tagDetails.tagName}-${index}`}
            tagDetails={tagDetails}
            onRemove={() => removeTagFromSelectedTagList(index)}
          />)

          )}
        </div>
      </div>

    </div>

  );
};

export default VideoTagsSelectContainer;
